import { c as _c } from "react/compiler-runtime";
import { Dialog, Form } from '@onefootprint/ui';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useEdit from '@/components/playbook-builder/hooks/use-edit';
type RenameDialogProps = {
  playbook: {
    id: string;
    name: string;
  };
  open: boolean;
  onOpenChange: (open: boolean) => void;
};
type RenameFormData = {
  name: string;
};
const RenameDialog = t0 => {
  const $ = _c(56);
  const {
    playbook,
    open,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "header.leftHeaderActions.renamePlaybook"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const mutation = useEdit();
  let t2;
  if ($[1] !== playbook.name) {
    t2 = {
      defaultValues: {
        name: playbook.name
      }
    };
    $[1] = playbook.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const form = useForm(t2);
  const {
    reset,
    handleSubmit,
    formState
  } = form;
  let t3;
  if ($[3] !== playbook.name || $[4] !== reset) {
    t3 = () => {
      reset({
        name: playbook.name
      });
    };
    $[3] = playbook.name;
    $[4] = reset;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== open || $[7] !== playbook.name || $[8] !== reset) {
    t4 = [open, playbook.name, reset];
    $[6] = open;
    $[7] = playbook.name;
    $[8] = reset;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== onOpenChange) {
    t5 = () => {
      onOpenChange(false);
    };
    $[10] = onOpenChange;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const close = t5;
  let t6;
  if ($[12] !== close || $[13] !== mutation) {
    t6 = async formData => {
      await mutation.mutateAsync({
        kind: "update_settings",
        name: formData.name
      });
      close();
    };
    $[12] = close;
    $[13] = mutation;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const onSubmit = t6;
  let t7;
  if ($[15] !== t) {
    t7 = t(_temp);
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== formState.isSubmitting || $[18] !== t7) {
    t8 = {
      form: "rename-playbook-form",
      label: t7,
      loading: formState.isSubmitting,
      type: "submit"
    };
    $[17] = formState.isSubmitting;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = formState.isSubmitting;
  let t10;
  if ($[20] !== t) {
    t10 = t(_temp2);
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== close || $[23] !== formState.isSubmitting || $[24] !== t10) {
    t11 = {
      disabled: t9,
      label: t10,
      onClick: close
    };
    $[22] = close;
    $[23] = formState.isSubmitting;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t(_temp3);
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== handleSubmit || $[29] !== onSubmit) {
    t13 = handleSubmit(onSubmit);
    $[28] = handleSubmit;
    $[29] = onSubmit;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t) {
    t14 = t(_temp4);
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t) {
    t15 = t(_temp5);
    $[33] = t;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t(_temp6);
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t16) {
    t17 = {
      required: t16
    };
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t14 || $[40] !== t15 || $[41] !== t17) {
    t18 = <Form.Input size="compact" label={t14} name="name" placeholder={t15} rules={t17} />;
    $[39] = t14;
    $[40] = t15;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t13 || $[44] !== t18) {
    t19 = <form id="rename-playbook-form" onSubmit={t13} className="flex flex-col gap-6">{t18}</form>;
    $[43] = t13;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== form || $[47] !== t19) {
    t20 = <FormProvider {...form}>{t19}</FormProvider>;
    $[46] = form;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== close || $[50] !== open || $[51] !== t11 || $[52] !== t12 || $[53] !== t20 || $[54] !== t8) {
    t21 = <Dialog onClose={close} open={open} isConfirmation={true} primaryButton={t8} secondaryButton={t11} size="compact" title={t12}>{t20}</Dialog>;
    $[49] = close;
    $[50] = open;
    $[51] = t11;
    $[52] = t12;
    $[53] = t20;
    $[54] = t8;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  return t21;
};
export default RenameDialog;
function _temp($) {
  return $.dialog.cta;
}
function _temp2($_0) {
  return $_0.dialog.cancel;
}
function _temp3($_1) {
  return $_1.dialog.title;
}
function _temp4($_2) {
  return $_2.dialog.name.label;
}
function _temp5($_3) {
  return $_3.dialog.name.placeholder;
}
function _temp6($_4) {
  return $_4.dialog.name.errors.required;
}